import { render } from "./AppHero.vue?vue&type=template&id=0b0ad660"
import script from "./AppHero.vue?vue&type=script&lang=js"
export * from "./AppHero.vue?vue&type=script&lang=js"

import "./AppHero.vue?vue&type=style&index=0&id=0b0ad660&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__